import { useEffect, useState } from "react";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import Spinner from "../Reusable/Spinner";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { queryClient } from "../../router";
import { useDebounce } from "../../customHooks/useDebounceHook";
import { useSearchParams } from "react-router-dom";
const BranchChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    id,
  } = props;

  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);
  const {
    data: branchChargeData,
    isLoading: DeliveryChargeLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      "branch-charge",
      `branch-charge-${localServiceBranch}-${localServiceType}-${Product_type}-${debounceSearch}-${id}`,
    ],
    url: APIS.BRANCH_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: localProductType
        ?.map((item: any) => item?.value)
        ?.join(","),
      delivery_charge_template: id,
      search: debounceSearch,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "branch",
      `branch-${localServiceBranch}-${localServiceType}-${Product_type}-${debounceSearch}-${id}`,
    ],
    navigateURL: ``,
  });

  const handleBranchChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string
  ) => {
    const url = `${APIS.BRANCH_CHARGE}`;
    let formData = {
      delivery_charge_template: id,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [branchChargeData]);

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      <div className={tw`w-52`}>
        <input
          type="text"
          placeholder="Search"
          value={searchQuery ?? ""}
          onChange={(e) => handleSearch(e?.target?.value)}
          className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
        />
      </div>
      {DeliveryChargeLoading || isRefetching ? (
        <Spinner />
      ) : (
        <div className={tw`w-full overflow-x-auto`}>
          <table className={tw`w-full`}>
            <thead className={tw`text-justify`}>
              <tr>
                <th className={tw`pr-12 whitespace-nowrap`}>
                  Destination City
                </th>
                <th className={tw`pr-12 whitespace-nowrap`}> Contact</th>
                <th className={tw`whitespace-nowrap px-8`}> District</th>
                <th className={tw`whitespace-nowrap px-8`}> Covered Area</th>
                {branchChargeData?.header?.map((item: any, index: number) => (
                  <th key={`product-type-${item?.id}`}>{item?.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {branchChargeData?.body?.map(
                (productType: any, index: number) => (
                  <tr
                    key={`service-city${productType?.location_id}`}
                    className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
                  >
                    <td
                      key={`service-city${productType?.location_id}`}
                      className={tw`py-2`}
                    >
                      {productType?.name}
                    </td>
                    <td
                      className={tw`pr-12 py-2`}
                      key={`service-city${productType?.location_id}`}
                    >
                      {productType?.branch_contact}
                    </td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 uppercase py-2`}
                    >
                      {productType?.district ?? "N/A"}
                    </td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 uppercase py-2 text-sm`}
                    >
                      {productType?.covered_area ?? "N/A"}
                    </td>
                    {productType?.rate?.map((item: any, index: number) => (
                      <td key={`rate-${index}`}>
                        <input
                          type="text"
                          className={tw`bg-transparent py-2`}
                          onBlur={(event: any) =>
                            handleBranchChargeChange(
                              productType?.location_id,
                              branchChargeData?.header?.[index]?.id,
                              event?.target?.value
                            )
                          }
                          defaultValue={item}
                        />
                      </td>
                    ))}
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BranchChargeTable;
